import { createContext, useContext } from 'react';
import type { Notice, Viewer } from '../lib/api';

export type DockPayload =
  | { kind: 'agent'; prompt?: string }
  | { kind: 'evidence'; notice?: Notice };

export interface ShellContextValue {
  viewer: Viewer | null;
  setViewer: (viewer: Viewer | null) => void;
  openDock: (payload?: DockPayload) => void;
  closeDock: () => void;
}

export const ShellContext = createContext<ShellContextValue | null>(null);

export function useShell() {
  const value = useContext(ShellContext);
  if (!value) throw new Error('useShell must be used inside AppShell');
  return value;
}
